export default __webpack_public_path__ + "static/media/accesorios.ff80f499.png";